// -------------------------------------------//
//              Dropdownfield
// -------------------------------------------//

angular.module('app.directives.select', []).directive('kermiSelect',
    ['$q', '$rootScope',
        function ($q, $rootScope) {
            var obj = {
                scope: {
                    // Set selectable Options
                    options: '=options',
                    // Object to Save
                    model: '=model',
                    prepareOptions: '=prepareOptions',
                    // CallBack when saved
                    kCallback: '=kCallback',
                    // CallBack when saved
                    kCallbackParams: '=kCallbackParams',
                    // withButtons
                    withButtons: '=withButtons',
                    // Suppress Apply on Write model
                    supressApply : '=supressApply'
                },
                restrict: 'AE',
                templateUrl: 'views/form/kermi-select.html',

                // -------------------------------------------//
                //              Link function
                // -------------------------------------------//
                link: function (scope, element, attrs, controller) {
                    scope.SelectOptions = [];

                    scope.selectThis = function (o) {
                        scope.selectedValue = o;
                        scope.value = o.Value;
                        scope.open = false;
                        scope.writeToModel();
                    };

                    scope.closeOtherOpenedSelects = () => {
                        scope.open = !scope.open;
                        if (scope.open) {
                            $rootScope.$broadcast('closeOtherOpenedSelects', { 'selectScope': scope });
                        }
                    };

                    scope.writeToModel = function () {

                        if (typeof scope.kCallback == 'function') {
                            var defer = $q.defer();
                            scope.kCallback({
                                promise: defer,
                                params: scope.kCallbackParams,
                                value: scope.value,
                                withButtons: scope.withButtons
                            });
                            // Write to Model if return value == true;
                            defer.promise.then(function( aktVal ){
                                // scope.model = scope.value;
                                scope.interact = false;
                                // We need to render by new model, because scope.model $watch does not fire in fact of scope.interact is true
                                // This is important if we change by Slider and datapoint directive shows buttons for save and clear
                                // While Buttons were shown no new data (e.g. interval) were parsed.
                                scope.model = aktVal;
                                let found = false;
                                for (var i = 0; i < scope.SelectOptions.length; i++) {
                                    if (scope.SelectOptions[i].Value.toString() === scope.model.toString()) {
                                        scope.selectedValue = scope.SelectOptions[i];
                                        found = i;
                                        break;

                                    }
                                }
                                if(found === false)
                                {
                                    scope.selectedValue = false;
                                }
                               // renderSliderByValue(scope.model);

                            });


                        } else {
                            // Nothing to check;
                            scope.model = scope.value;
                            // Careful using this.
                            // Without a callback (Scenes SetDatapoint) we can run into performance issues
                            // But we need this because Parent Object needs dirtyCheck cycle to display current value
                            // Todo: In future use pherhaps implement a scope.supressApply to handle this
                            if(scope.supressApply){ return; }
                            scope.$apply();
                        }

                    };

                    scope.prepareOptionsFn = function (value) {
                        let a;
                        switch (scope.prepareOptions) {
                            case "PossibleValues" :
                                a = [];
                                for (var key in value) {
                                    if (value.hasOwnProperty(key))
                                    {

                                        var val = key;
                                        if(key =='false'){ val = false;}
                                        if(key =='true'){ val = true;}

                                        var o = {'DisplayName': value[key], "Value": val};
                                        a.push(o);
                                    }

                                }
                                scope.SelectOptions = a;
                                break;
                            case "Enum" :
                                a = [];
                                for (var key2 in value) {
                                    if (value.hasOwnProperty(key2) && value[key2].DisplayName) {
                                        var o2 = {'DisplayName': value[key2].DisplayName, "Value": key2};
                                        a.push(o2);
                                    }

                                }
                                scope.SelectOptions = a;
                                break;
                            default:
                                scope.SelectOptions = value;
                        }
                    };

                    scope.$watch('options', function (value) {
                        if (value !== scope.SelectOptions || scope.SelectOptions == undefined) {
                            scope.prepareOptionsFn(value);

                            var found = false;
                            if (!scope.selectedValue) {
                                scope.selectedValue = scope.model;
                            }

                            if (scope.selectedValue != undefined) {
                                for (var i = 0; i < scope.SelectOptions.length; i++) {
                                    if (scope.SelectOptions[i].Value == scope.selectedValue.Value) {
                                        scope.selectedValue = scope.SelectOptions[i];
                                        found = true;
                                    }

                                }
                            }

                            if (!found) {
                                scope.selectedValue = undefined;
                            }
                        } else {
                            scope.selectedValue = undefined;
                            scope.options = scope.SelectOptions;
                        }
                    }, true);

                    scope.$watch('model', function () {
                        scope.init();
                    });
                    scope.init = function () {
                        if (typeof scope.model != 'undefined' && typeof scope.options != 'undefined') {
                            scope.prepareOptionsFn(scope.options);
                            var found = false;
                            for (var i = 0; i < scope.SelectOptions.length; i++) {
                                if (scope.SelectOptions[i].Value.toString() === scope.model.toString()) {
                                    scope.selectedValue = scope.SelectOptions[i];
                                    found = i;
                                    break;

                                }
                            }
                            if(found === false)
                            {
                                scope.selectedValue = false;
                            }
                        }
                    };
                    scope.init();

                }
            };
            return obj;


        }]);
